import { Document } from "mongoose"

export interface IProduct {
  _id?: string
  id?: string
  productType: string
  term: number
  interestOnlyPeriod: number
  apr: number
  autoPayAPR: number
  interestRateWithAutopay: number
  interestRateWithoutAutopay: number
  paymentFactorWithAutopay: number
  paymentFactorWithoutAutopay: number
  dealerFee: number
  maxPpw: number
  maxLoanAmount: number
  minLoanAmount: number
  disclosures: string
  approvedStates: string[]
  productDescription: string
  detailedProductDescriptionClientHtml: string
  detailedProductDescriptionInstallerHtml: string
  decisionProProductName: string
  equipmentTypes: string[]
  effectiveDate?: Date
  expirationDate?: Date
  prequalExpirationDate?: Date
  isValidForIncentive?: boolean
}

export type ProductDocument = IProduct & Document

export const ALLOWED_PRODUCT_UPDATE_FIELDS = [
  'productType',
  'term',
  'interestOnlyPeriod',
  'apr',
  'autoPayAPR',
  'interestRateWithAutopay',
  'interestRateWithoutAutopay',
  'paymentFactorWithAutopay',
  'paymentFactorWithoutAutopay',
  'dealerFee',
  'maxPpw',
  'maxLoanAmount',
  'minLoanAmount',
  'disclosures',
  'approvedStates',
  'productDescription',
  'detailedProductDescriptionClientHtml',
  'detailedProductDescriptionInstallerHtml',
  'decisionProProductName',
  'equipmentTypes',
  'effectiveDate',
  'expirationDate',
  'prequalExpirationDate',
  'isValidForIncentive',
] as const

export const getProductName = (product: IProduct, incentiveSelected: boolean): string => {
  if (product?.term === 366 && incentiveSelected === true) {
    return 'MCGB Pilot2 30 Year 2.99%'
  } else if (product?.term === 246 && incentiveSelected === true) {
    return 'MCGB Pilot2 20 Year 2.99%'
  } else {
    return product?.decisionProProductName
  }
}

export const EQUIPMENT_TYPES_LABELS: Record<string, string> = {
  'tesla-roof': 'Tesla Roof + Powerwall 3',
  'tesla-solar': 'Tesla Solar Panels + Powerwall 3',
  'standard-solar': 'Standard Solar',
  'storage-only': 'Storage Only'
}
